import React from "react";
import "./workshop.css";

function Workshop() {
  return (
    <div>
      <div>
        <h2 className="workshop-heading">Workshops</h2>
      </div>
      <div className="container">
        <p>
          Experts who are working in the fields of special education, creative
          play, physiotherapy, speech therapy and occupational therapy conduct
          workshop for staff and parents to keep them abreast of the latest
          trends and resources with regard to care and support of children with
          special needs.
        </p>
      </div>
    </div>
  );
}

export default Workshop;
